import ViewTitle from './ViewTitle'

export default ViewTitle
